import React, { useState } from "react";
import "./CheckInputForm.css";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import LoaderVWC from "../components/LoaderVWC";
import PersonIcon from "@mui/icons-material/Person";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import WarningIcon from "@mui/icons-material/Warning";
import TaskIcon from "@mui/icons-material/Task";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Divider,
  Chip,
  Radio,
} from "@mui/material";
import Error from "../components/Error";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Trans, useTranslation } from "react-i18next";
import useHttp from "../hooks/use-http";
import DropzoneUploader from "../components/DropzoneUploader";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
});

const StyledRadio = ({ ...props }) => {
  return (
    <Radio
      {...props}
      sx={{
        color: "#DCEDFA",
        "&.Mui-checked": {
          color: "#439BD9",
        },

        ...props.sx,
      }}
    />
  );
};

const FormWK = ({
  runConfig,
  setRunConfig,
  startRun,
  runLoading,
  runError,
}) => {
  const [isSummaryView, setIsSummaryView] = useState(false);
  const [hideError, setHideError] = useState(false);
  const [accessCodeValid, setAccessCodeValid] = useState(false);
  const [financieringChecked, setFinancieringChecked] = useState(0);
  const [keuringChecked, setKeuringChecked] = useState(0);
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  const {
    sendRequest: validateAccessCodeRequest,
    isLoading: validateAccessCodeLoading,
    error: validateAccessCodeError,
  } = useHttp();

  function validateAccessCode() {
    validateAccessCodeRequest(
      {
        url: `${REACT_APP_BACKEND_URL}/run/validate-access-code`,
        method: "POST",
        body: {
          access_code: runConfig.access_code,
          module_name: "Woning kopen",
        },
      },
      (data) => {
        if (data.valid) {
          setAccessCodeValid(true);
        } else {
          setAccessCodeValid(false);
          // notication todo
        }
      }
    );
  }

  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));

  function handleResetForm() {
    setHideError(true);
    setIsSummaryView(false);
  }

  function startRunHandler() {
    setHideError(false);
    startRun(false);
  }

  return (
    <div className="nc-form">
      <div className="nc-form-input">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "8px",
          }}
        >
          <span className="nc-form-title">{t("module.Woning kopen")}</span>
          <Chip
            label={t("Gratis")}
            sx={{
              backgroundColor: "#10B981",
              color: "#fff",
              fontSize: "16px",
              fontWeight: 600,
              height: "32px",
              "& .MuiChip-label": {
                paddingX: "16px",
              },
            }}
          />
        </div>
        <span className="nc-form-subtitle">
          {isSummaryView ? (
            <span>{t("controleerJeGegevensText")}</span>
          ) : (
            <span>{t("fillOutYourDetails")}</span>
          )}
        </span>
        <Divider sx={{ width: "100%", marginBottom: "24px" }} />
        <div className="nc-form-main">
          {!isSummaryView && (
            <React.Fragment>
              <div className="nc-inputs">
                <span className="nc-inputs-title">
                  <PersonIcon sx={{ color: "#439BD9" }} />
                  {t("persoonlijkeGegevens")}
                </span>
                <div className="nc-textfields">
                  <TextField
                    label={t("naam")}
                    variant="outlined"
                    value={runConfig?.name || ""}
                    onChange={(e) =>
                      setRunConfig({ ...runConfig, name: e.target.value })
                    }
                    required
                    sx={{
                      backgroundColor: "#F9FCFE",
                      border: "1px solid #ECF5FD",
                    }}
                  />
                  <TextField
                    label="Email"
                    email
                    variant="outlined"
                    value={runConfig?.email || ""}
                    onChange={(e) =>
                      setRunConfig({ ...runConfig, email: e.target.value })
                    }
                    required
                    sx={{
                      backgroundColor: "#F9FCFE",
                      border: "1px solid #ECF5FD",
                    }}
                  />
                </div>

                <div className="nc-textfields mt-1">
                  <span className="nc-inputs-title">
                    <VpnKeyIcon sx={{ color: "#439BD9" }} />
                    {t("toegangscode")}
                    {accessCodeValid && (
                      <CheckCircleIcon
                        sx={{
                          color: "#10B981",
                          fontSize: "24px",
                          marginLeft: "8px",
                          animation:
                            "checkmark-pop 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                          "@keyframes checkmark-pop": {
                            "0%": {
                              transform: "scale(0) rotate(-45deg)",
                              opacity: 0,
                            },
                            "50%": {
                              transform: "scale(1.2) rotate(0deg)",
                            },
                            "100%": {
                              transform: "scale(1) rotate(0deg)",
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    )}
                  </span>
                  <div
                    className="nc-access-code-container"
                    style={{
                      display: "flex",
                      flexDirection: mobile ? "column" : "row",
                      justifyContent: mobile ? "center" : "flex-start",
                      alignItems: mobile ? "stretch" : "center",
                      gap: mobile ? "12px" : "16px",
                    }}
                  >
                    <TextField
                      label={t("toegangscode")}
                      variant="outlined"
                      value={runConfig?.access_code || ""}
                      onChange={(e) =>
                        setRunConfig({
                          ...runConfig,
                          access_code: e.target.value,
                        })
                      }
                      required
                      sx={{
                        flex: 1,
                        backgroundColor: "#F9FCFE",
                        border: "1px solid #ECF5FD",
                      }}
                    />
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Button
                        variant="contained"
                        onClick={validateAccessCode}
                        disabled={
                          runConfig?.access_code?.trim() === "" ||
                          !runConfig?.access_code ||
                          validateAccessCodeLoading ||
                          accessCodeValid
                        }
                        sx={{
                          backgroundColor: "#E27C00",
                          color: "#fff",
                          borderRadius: "40px",
                          textTransform: "none",
                          paddingX: "32px",
                          "&:hover": {
                            backgroundColor: "#C96D00",
                          },
                        }}
                      >
                        Indienen
                      </Button>
                    </Box>
                  </div>
                  <div
                    className="flex toegangscode-text"
                    style={{
                      margin: mobile ? "auto" : "0px",
                      padding: "16px",
                      background: "#F0F7FC",
                      borderRadius: "16px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#000",
                        padding: "0px 8px",
                        lineHeight: "180%",
                      }}
                    >
                      <Trans
                        i18nKey="testDisclaimerShort"
                        components={{
                          bold: <strong style={{ color: "#439BD9" }} />,
                        }}
                      />
                    </span>
                  </div>
                </div>

                <span className="nc-inputs-title mt-1">
                  <UploadFileIcon sx={{ color: "#439BD9" }} />
                  Upload {t("koopakte")}
                </span>

                <div className="nc-upload-container">
                  <div className="nc-upload-field mb-1">
                    {runConfig.contract_file ? (
                      <div
                        className="nc-file-uploaded"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "16px 20px",
                          backgroundColor: "#F0F7FC",
                          border: "2px solid #DCEDFA",
                          borderRadius: "12px",
                          minHeight: "80px",
                          width: mobile ? "100%" : "90%",
                          minWidth: 0,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            minWidth: 0,
                            flex: 1,
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "40px",
                              height: "40px",
                              backgroundColor: "#439BD9",
                              borderRadius: "8px",
                              flexShrink: 0,
                            }}
                          >
                            <UploadFileIcon
                              sx={{ color: "#fff", fontSize: "20px" }}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "2px",
                              minWidth: 0,
                              flex: 1,
                              overflow: "hidden",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: 500,
                                color: "#0F3A58",
                                lineHeight: "1.2",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "50vw",
                              }}
                            >
                              {runConfig?.contract_file?.name || ""}
                            </span>
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#6B7280",
                                fontWeight: 400,
                              }}
                            >
                              {runConfig?.contract_file?.size
                                ? `${Math.round(
                                    runConfig.contract_file.size / 1024
                                  )} KB`
                                : "Bestand geüpload"}
                            </span>
                          </div>
                        </div>
                        <DeleteIcon
                          onClick={() =>
                            setRunConfig({ ...runConfig, contract_file: null })
                          }
                          sx={{
                            cursor: "pointer",
                            color: "#6B7280",
                            fontSize: "20px",
                            flexShrink: 0,
                            "&:hover": { color: "#EF4444" },
                          }}
                        />
                      </div>
                    ) : (
                      <div style={{ width: "90%" }}>
                      <DropzoneUploader
                        onFileChange={(file) =>
                          setRunConfig({
                            ...runConfig,
                            contract_file: file[0],
                          })
                        }
                      />
                    </div>
                    )}
                  </div>
                </div>

                {/* <span
                  className="nc-inputs-title"
                >
                  <TranslateIcon sx={{ color: "#439BD9" }} />
                  {t("gewensteTaal")}
                </span>
                <div className="nc-textfields">

                <LanguageSelect handleSelectLanguage={(e) =>  setRunConfig({ ...runConfig, language: e })} />
                </div> */}
                {runConfig.hasTerms && (
                  <div className="nc-upload-container">
                    <div className="nc-upload-field mb-1">
                      <Button
                        component="label"
                        color="secondary"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        sx={{
                          border: "2px dashed #2484C848",
                          borderRadius: "8px",
                          padding: "24px",
                          minHeight: "120px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#F9FCFE",
                          backgroundImage: `repeating-linear-gradient(
                            transparent,
                            transparent 8px,
                            #439BD9 8px,
                            #439BD9 12px,
                          )`,
                          width: "120px",
                          backgroundSize: "2px 3px",
                          backgroundPosition:
                            "top left, top right, bottom right, bottom left",
                        }}
                        // disabled={selectedModule === null}
                        startIcon={
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#000",
                              transform: "translateX(4px)",
                            }}
                          >
                            <UploadFileIcon
                              htmlColor="#439BD9"
                              sx={{ marginRight: "0!important" }}
                            />
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#439BD9",
                                fontWeight: 500,
                                textTransform: "none",
                              }}
                            >
                              Upload
                            </span>
                          </div>
                        }
                      >
                        <VisuallyHiddenInput
                          type="file"
                          onChange={(e) =>
                            setRunConfig({
                              ...runConfig,
                              gtc_file: e.target.files[0],
                            })
                          }
                        />
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              <div className="disclaimer-container">
                <div className="nc-textfields mt-1">
                  <span className="nc-inputs-title">
                    <InfoIcon sx={{ color: "#439BD9" }} />
                    {t("gegevensKoop")}
                  </span>

                  <div style={{ marginTop: "16px", lineHeight: "200%" }}>
                    <b>{t("financieringsVoorbehoud")}</b>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#0F3A58",
                        display: "block",
                        marginBottom: "12px",
                      }}
                    >
                      {t("financieringVoorbehoudVraag")}
                    </span>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        marginLeft: "4px",
                      }}
                    >
                      <FormControlLabel
                        control={<StyledRadio />}
                        label={t("ja")}
                        checked={financieringChecked === 0}
                        onChange={() => {
                          setFinancieringChecked(0);
                          setRunConfig({
                            ...runConfig,
                            financiering_voorbehoud: 0,
                          });
                        }}
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                            fontWeight: 400,
                          },
                        }}
                      />
                      <FormControlLabel
                        control={<StyledRadio />}
                        label={t("nee")}
                        checked={financieringChecked === 1}
                        onChange={() => {
                          setFinancieringChecked(1);
                          setRunConfig({
                            ...runConfig,
                            financiering_voorbehoud: 1,
                          });
                        }}
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                            fontWeight: 400,
                          },
                        }}
                      />
                      <FormControlLabel
                        control={<StyledRadio />}
                        label={t("weetIkNogNiet")}
                        checked={financieringChecked === 2}
                        onChange={() => {
                          setFinancieringChecked(2);
                          setRunConfig({
                            ...runConfig,
                            financiering_voorbehoud: 2,
                          });
                        }}
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                            fontWeight: 400,
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ marginTop: "24px", lineHeight: "200%" }}>
                    <b>{t("bouwkundigeKeuring")}</b>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#0F3A58",
                        display: "block",
                        marginBottom: "12px",
                      }}
                    >
                      {t("keuringVoorbehoudVraag")}
                    </span>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        marginLeft: "4px",
                      }}
                    >
                      <FormControlLabel
                        control={<StyledRadio />}
                        label={t("ja")}
                        checked={keuringChecked === 0}
                        onChange={() => {
                          setKeuringChecked(0);
                          setRunConfig({
                            ...runConfig,
                            bouwkundige_keuring: 0,
                          });
                        }}
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                            fontWeight: 400,
                          },
                        }}
                      />
                      <FormControlLabel
                        control={<StyledRadio />}
                        label={t("nee")}
                        checked={keuringChecked === 1}
                        onChange={() => {
                          setKeuringChecked(1);
                          setRunConfig({
                            ...runConfig,
                            bouwkundige_keuring: 1,
                          });
                        }}
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                            fontWeight: 400,
                          },
                        }}
                      />
                      <FormControlLabel
                        control={<StyledRadio />}
                        label={t("weetIkNogNiet")}
                        checked={keuringChecked === 2}
                        onChange={() => {
                          setKeuringChecked(2);
                          setRunConfig({
                            ...runConfig,
                            bouwkundige_keuring: 2,
                          });
                        }}
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                            fontWeight: 400,
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="proceed-btn">
                  <Button
                    variant="contained"
                    color="secondary"
                    sx={{
                      color: "#fff",
                      borderRadius: "40px",
                      textTransform: "none",
                    }}
                    onClick={() => setIsSummaryView(true)}
                    disabled={
                      runConfig?.agreed === false ||
                      runConfig?.disclaimer_agreed === false ||
                      runConfig?.contract_file === null ||
                      !runConfig?.contract_file ||
                      runConfig?.access_code === "" ||
                      !runConfig?.access_code ||
                      runConfig?.name === "" ||
                      runConfig?.email === ""
                    }
                  >
                    {t("bevestigen")}
                  </Button>
                </div>
              </div>
            </React.Fragment>
          )}
          {isSummaryView && (
            <React.Fragment>
              <div className="nc-summary">
                <span className="nc-inputs-title mb-1">
                  <TaskIcon sx={{ color: "#439BD9" }} />
                  {t("samenvatting")}
                </span>
                <div className="nc-summary-content">
                  <div className="nc-summary-row">
                    <label>{t("naam")}</label>
                    <span>{`${runConfig?.name || ""}`}</span>
                  </div>
                  <div className="nc-summary-row">
                    <label>E-mail</label>
                    <span>{runConfig?.email || ""}</span>
                  </div>
                  {/* <div className="nc-summary-row">
                    <label>{t("taal")}</label>
                    <span>{runConfig?.language || ""}</span>
                  </div> */}
                  {/* <div className="nc-summary-row">
                    <label>{t("heeftDoorgehaaldeTekst")}</label>
                    <span>
                      {runConfig?.hasStrikethrough ? t("ja") : t("nee")}
                    </span>
                  </div> */}
                  <div className="nc-summary-row">
                    <label>{t("Koopakte")}</label>
                    <span>
                      {runConfig.contract_file
                        ? runConfig?.contract_file.name
                        : "Geen bestand"}
                    </span>
                  </div>
                  <div className="nc-summary-row">
                    <label>{t("toegangscode")}</label>
                    <span>{runConfig?.access_code || ""}</span>
                  </div>
                  <div className="nc-summary-row">
                    <label>{t("financieringVoorbehoudVraag")}</label>
                    <span>
                      {runConfig?.financiering_voorbehoud === 0
                        ? t("ja")
                        : runConfig?.financiering_voorbehoud === 1
                        ? t("nee")
                        : runConfig?.financiering_voorbehoud === 2
                        ? t("weetIkNogNiet")
                        : "-"}
                    </span>
                  </div>
                  <div className="nc-summary-row">
                    <label>{t("keuringVoorbehoudVraag")}</label>
                    <span>
                      {runConfig?.bouwkundige_keuring === 0
                        ? t("ja")
                        : runConfig?.bouwkundige_keuring === 1
                        ? t("nee")
                        : runConfig?.bouwkundige_keuring === 2
                        ? t("weetIkNogNiet")
                        : "-"}
                    </span>
                  </div>
                  {/* <div className="nc-summary-row">
                    <label>Algemene voorwaarden huurcontract</label>
                    <span>
                      {runConfig.contract_file
                        ? runConfig?.termsFile?.name
                        : "(Geen)"}
                    </span>
                  </div> */}
                </div>
              </div>

              <div className="nc-summary-confirm">
                {runLoading ? (
                  <div className="run-loading">
                    <LoaderVWC inline message={t("checkInUitvoering")} />
                    {runConfig?.contract_has_strikethrough && (
                      <div className="run-loading-info-text">
                        <p style={{ fontFamily: "Lato", marginTop: "8px" }}>
                          {t("doorgehaaldeTekstInfo")}
                        </p>
                      </div>
                    )}
                  </div>
                ) : runError && hideError === false ? (
                  <React.Fragment>
                    <Error statusCode={runError.status} detail={runError} />
                    <Button
                      variant="contained"
                      sx={{
                        color: "#439BD9",
                        backgroundColor: "#D7E9F7",
                        borderRadius: "40px",
                        textTransform: "none",
                        width: "100px",
                      }}
                      onClick={handleResetForm}
                    >
                      {t("terug")}
                    </Button>
                  </React.Fragment>
                ) : (
                  <>
                    <div className="disclaimer-content">
                      <span
                        className="nc-inputs-title"
                        style={{ marginBottom: "-16px" }}
                      >
                        Disclaimer
                      </span>

                      <p
                        style={{
                          fontFamily: "Lato",
                          lineHeight: "180%",
                          fontSize: "14px",
                        }}
                      >
                        {t("testDisclaimerLong")} {t("testDisclaimerLong2")}
                      </p>

                      <span className="nc-inputs-title">
                        {t("Teamreview inschakelen")}
                      </span>
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{
                              color: "#439BD9",
                              justifyContent: "start",
                            }}
                          />
                        }
                        label={t("handmatigeReviewToestaanText")}
                        checked={runConfig?.share_with_team}
                        onChange={(e) =>
                          setRunConfig({
                            ...runConfig,
                            share_with_team: e.target.checked,
                          })
                        }
                        sx={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "start",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px", // of een andere gewenste grootte
                            fontWeight: 400,
                            lineHeight: "180%",
                          },
                        }}
                      />

                      {!runConfig?.share_with_team && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "8px",
                            padding: "12px 16px",
                            backgroundColor: "#FEF3CD",
                            border: "1px solid #F59E0B50",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          <WarningIcon
                            sx={{
                              color: "#F59E0B",
                              fontSize: "20px",
                              marginTop: "2px",
                              flexShrink: 0,
                            }}
                          />
                          <div style={{ flex: 1 }}>
                            <p
                              style={{
                                margin: 0,
                                fontSize: "13px",
                                lineHeight: "1.5",
                                color: "#92400E",
                                fontWeight: 400,
                              }}
                            >
                              <strong>{t("Let op")}:</strong>{" "}
                              {t("teamreviewWaarschuwingText")}
                            </p>
                          </div>
                        </div>
                      )}

                      <span className="nc-inputs-title">
                        {t("toestemming")}
                      </span>
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{
                              color: "#439BD9",
                              justifyContent: "start",
                            }}
                          />
                        }
                        label={
                          i18n.language === "nl" ? (
                            <Trans
                              i18nKey="avwAkkoord"
                              components={{
                                avw: (
                                  <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://voorwaardenchecker.nl/nl/algemene-voorwaarden"
                                  >
                                    Algemene Voorwaarden
                                  </a>
                                ),
                                privacyverklaring: (
                                  <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://voorwaardenchecker.nl/nl/privacyverklaring"
                                  >
                                    Privacyverklaring
                                  </a>
                                ),
                              }}
                            />
                          ) : (
                            <Trans
                              i18nKey="avwAkkoord"
                              components={{
                                avw: (
                                  <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://checkyourterms.com/en/terms-and-conditions"
                                  >
                                    Terms and Conditions
                                  </a>
                                ),
                                privacyverklaring: (
                                  <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://checkyourterms.com/en/privacy-statement"
                                  >
                                    Privacy statement
                                  </a>
                                ),
                              }}
                            />
                          )
                        }
                        checked={runConfig?.agreed}
                        onChange={(e) =>
                          setRunConfig({
                            ...runConfig,
                            agreed: e.target.checked,
                          })
                        }
                        sx={{
                          display: "flex",
                          gap: "10px",
                          marginBottom: "16px",
                          alignItems: "start",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px", // of een andere gewenste grootte
                            fontWeight: 400,
                            lineHeight: "180%",
                          },
                        }}
                      />
                      <div className="start-check-btns">
                        <Button
                          variant="contained"
                          sx={{
                            color: "#439BD9",
                            backgroundColor: "#D7E9F7",
                            borderRadius: "40px",
                            textTransform: "none",
                          }}
                          onClick={() => setIsSummaryView(false)}
                        >
                          {t("terug")}
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          sx={{
                            color: "#fff",
                            borderRadius: "40px",
                            textTransform: "none",
                          }}
                          onClick={startRunHandler}
                        >
                          {t("starten")}
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormWK;
